/* jshint esversion: 6 */
import React from 'react';
import { FormattedRelativeTime } from 'react-intl';

class FormattedRelativeWrapper extends React.Component {
    render() {
        let { value, ...otherProps } = this.props,
            elapsed = new Date().getTime() - new Date(value).getTime(),
            absElapsed = Math.abs(elapsed),
            msPerMinute = 60 * 1000,
            msPerHour = msPerMinute * 60,
            msPerDay = msPerHour * 24,
            msPerWeek = msPerDay * 7,
            msPerMonth = msPerDay * 30,
            msPerYear = msPerDay * 365,
            unit = 'second',
            diffValue = 0;

        if (absElapsed < msPerMinute) {
            unit = 'second';
            diffValue = -Math.floor(elapsed/1000);
        } else if (absElapsed < msPerHour) {
            unit = 'minute';
            diffValue = -Math.floor(elapsed/msPerMinute);
        } else if (absElapsed < msPerDay) {
            unit = 'hour';
            diffValue = -Math.floor(elapsed/msPerHour);
        } else if (absElapsed < msPerWeek) {
            unit = 'day';
            diffValue = -Math.floor(elapsed/msPerDay);
        } else if (absElapsed < msPerMonth) {
            unit = 'week';
            diffValue = -Math.floor(elapsed/msPerWeek);
        } else if (absElapsed < msPerYear) {
            unit = 'month';
            diffValue = -Math.floor(elapsed/msPerMonth);
        } else {
            unit = 'year';
            diffValue = -Math.floor(elapsed/msPerYear);
        }

        return (
            <FormattedRelativeTime {...otherProps} value={diffValue} unit={unit} numeric="auto"/>
        );
    }
}

export default FormattedRelativeWrapper;
